export enum jobResultsHeaderTestIds {
  RESULT_HEADER_MODE_LIST = "result-header-mode-list",
  RESULT_HEADER_MODE_MAP = "result-header-mode-map",
  RESULT_HEADER_PAGINATION_CONTAINER = "result-header-pagination-container",
  RESULT_HEADER_ALERTS_BUTTON = "result-header-alerts-button",
}

export enum mobileActionBarTestIds {
  ALERTS_BUTTON = "mobile-action-bar-alerts-button",
}

export enum jobHeaderTestIds {
  JOB_HEADER = "job-header",
  JOB_TITLE = "job-title",
  JOB_CATEGORY = "job-category",
  JOB_META_INFO = "job-meta-info",
  JOB_DATE_POSTED = "job-date-posted",
  JOB_TYPE = "job-type",
}

export enum directionAndShareButtonsTestIds {
  CONTAINER = "direction-and-share-buttons",
  GET_DIRECTIONS_BUTTON = "direction-and-share-get-directions-button",
  SHARE_BUTTON = "direction-and-share-share-button",
}

export enum jobViewActionsTestIds {
  JOB_VIEW_ACTIONS = "job-view-actions",
  JOB_VIEW_ACTIONS_EXPRESS_INTEREST_BUTTON = "job-view-actions-express-interest-button",
  JOB_VIEW_ACTIONS_QUICK_APPLY_BUTTON = "job-view-actions-quick-apply-button",
  JOB_VIEW_ACTIONS_QUICK_APPLY_ERROR = "job-view-actions-quick-apply-error",
  JOB_VIEW_ACTIONS_QUICK_APPLY_SIGN_IN = "job-view-actions-quick-apply-sign-in",
  JOB_VIEW_ACTIONS_EXTERNAL_APPLICATION_LINK = "job-view-actions-external-application-link",
  JOB_VIEW_ACTIONS_MORE_JOBS_AT_SCHOOL_BUTTON = "job-view-actions-more-jobs-at-school",
}

export enum jobClearFiltersTestIds {
  JOB_CLEAR_FILTERS_COUNT_EL = "job-clear-filters-count-el",
  JOB_CLEAR_FILTERS_BUTTON = "job-clear-filters-button",
}

export enum jobFiltersTestIds {
  LOCATION_FILTER = "job-filters-location-input",
  LOCATION_MAP_CONTAINER = "job-filters-location-map",
  SHOW_SCHOOLS_NO_ROLES = "job-filters-show-schools-no-roles",
  SUBJECT_FILTER = "job-filters-subject",
  DISTRICT_FILTER = "job-filters-district",
  SCHOOL_FILTER = "job-filters-school",
  GRADE_GROUP_FILTER = "job-filters-grade-group",
  GRADE_FILTER_PK = "job-filters-grade-pk",
  GRADE_FILTER_KG = "job-filters-grade-kg",
  GRADE_FILTER_1 = "job-filters-grade-1",
  GRADE_FILTER_2 = "job-filters-grade-2",
  GRADE_FILTER_3 = "job-filters-grade-3",
  GRADE_FILTER_4 = "job-filters-grade-4",
  GRADE_FILTER_5 = "job-filters-grade-5",
  GRADE_FILTER_6 = "job-filters-grade-6",
  GRADE_FILTER_7 = "job-filters-grade-7",
  GRADE_FILTER_8 = "job-filters-grade-8",
  GRADE_FILTER_9 = "job-filters-grade-9",
  GRADE_FILTER_10 = "job-filters-grade-10",
  GRADE_FILTER_11 = "job-filters-grade-11",
  GRADE_FILTER_12 = "job-filters-grade-12",
  TAKE_QUIZ_BUTTON = "job-filters-take-quiz-button",
  QUICK_APPLY_FILTER = "job-quick-apply-filter",
  SAVED_SCHOOLS_FILTER = "job-saved-schools-filter",
  LOCATION_FILTER_RECENT = "job-filters-location-recent",
  LOCATION_FILTER_TOP_CITY = "job-filters-location-top-city",
  LOCATION_FILTER_PREDICTION = "job-filters-location-prediction",
  LOCATION_FILTER_NEARBY = "job-filters-location-nearby",
  SAVED_SEARCHES_PREFERENCES_TOGGLE = "job-filters-preferences-toggle",
  SAVED_SEARCHES_PREFERENCES_EDIT_LINK = "job-filters-preferences-edit-link",
  SAVED_SEARCHES_LIST_ROW = "job-filters-saved-searches-row",
}

export enum jobMapTestIds {
  MAP_CONTAINER = "map-container",
  MAP_PIN = "map-pin",
  MAP_ZOOM_IN = "map-zoom-in",
  MAP_ZOOM_OUT = "map-zoom-out",
  MAP_SCHOOL_COUNT = "map-school-count",
}

export enum jobPaginationTestIds {
  PREV_BUTTON = "job-search-pagination-prev",
  NEXT_BUTTON = "job-search-pagination-next",
}

export enum deprecatedBoardModalTestIds {
  MODAL = "deprecated-board-modal",
  CONTACT_ORGANIZATION_BUTTON = "deprecated-board-modal-contact-organization-button",
  BROWSE_OTHER_STATES_LINK = "deprecated-board-modal-browse-other-states-link",
  APPLICATIONS_LINK = "deprecated-board-modal-applications-link",
}

export enum jobBoardSwitchModalTestIds {
  SWITCH_CONFIRM_BUTTON = "job-board-switch-modal-confirm-button",
  SWITCH_CANCEL_BUTTON = "job-board-switch-modal-cancel-button",
  NOT_SUPPORTED_CONTINUE_BUTTON = "job-board-switch-modal-not-supported-continue-button",
  GUEST_SIGN_IN_BUTTON = "job-board-switch-modal-guest-sign-in-button",
  GUEST_CONTINUE_BUTTON = "job-board-switch-modal-guest-continue-button",
}
